import React from 'react';
import { Download, FileSpreadsheet } from 'lucide-react';
import { Button } from '../../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../../components/ui/dialog';

/**
 * Diálogo para descargar plantilla Excel con selector visual de destinos
 */
const TemplateDownloadDialog = ({
  open,
  onOpenChange,
  onDownload,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="template-download-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <FileSpreadsheet className="text-blue-600" size={20} />
            Selecciona el Destino
          </DialogTitle>
          <DialogDescription>
            Elige el destino para descargar la plantilla con los campos específicos.
          </DialogDescription>
        </DialogHeader>
        
        <div className="grid grid-cols-2 gap-3 py-4">
          <Button
            variant="outline"
            className="h-auto py-4 flex flex-col items-center gap-2 border-2 hover:border-blue-500 hover:bg-blue-50"
            onClick={() => onDownload('ANMAR')}
            data-testid="template-btn-anmar"
          >
            <span className="font-bold text-blue-600">ANMAR</span>
            <span className="text-xs text-gray-500">Ensayos y fechas</span>
          </Button>
          
          <Button
            variant="outline"
            className="h-auto py-4 flex flex-col items-center gap-2 border-2 hover:border-green-500 hover:bg-green-50"
            onClick={() => onDownload('GAIKER')}
            data-testid="template-btn-gaiker"
          >
            <span className="font-bold text-green-600">GAIKER</span>
            <span className="text-xs text-gray-500">Presupuestos</span>
          </Button>
          
          <Button
            variant="outline"
            className="h-auto py-4 flex flex-col items-center gap-2 border-2 hover:border-purple-500 hover:bg-purple-50"
            onClick={() => onDownload('IVAMI')}
            data-testid="template-btn-ivami"
          >
            <span className="font-bold text-purple-600">IVAMI</span>
            <span className="text-xs text-gray-500">Ensayo IVAMI</span>
          </Button>
          
          <Button
            variant="outline"
            className="h-auto py-4 flex flex-col items-center gap-2 border-2 hover:border-orange-500 hover:bg-orange-50"
            onClick={() => onDownload('REGULATORY')}
            data-testid="template-btn-regulatory"
          >
            <span className="font-bold text-orange-600">REGULATORY</span>
            <span className="text-xs text-gray-500">Básico</span>
          </Button>
        </div>

        <div className="border-t pt-3">
          <Button
            variant="ghost"
            className="w-full text-gray-600"
            onClick={() => onDownload(null)}
            data-testid="template-btn-general"
          >
            <Download size={16} className="mr-2" />
            Descargar plantilla general (todos los campos)
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TemplateDownloadDialog;
